var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showStartView)?_c('Start'):_vm._e()],1),(!_vm.showStartView)?_c('Dialogue'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }